import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { InvoicesComponent } from './invoices.component';
import { SharedModule } from 'app/shared/shared.module';
import { InvoicesOptionsComponent } from './invoices-options/invoices-options.component';
import { InvoiceContainerComponent } from './invoice/invoice.container';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoiceRecordComponent } from './invoice-record/invoice-record.component';
import { InvoicesListModule } from './invoices-list/invoices-list.module';
import { CaseNamePipe } from './case-name.pipe';
import { ChangeCurrencyComponent } from './change-currency/change-currency.component';
import { InterimInvoicingModalComponent } from './interim-invoicing-modal/interim-invoicing-modal.component';
import { InterimInvoicingListComponent } from './interim-invoicing-list/interim-invoicing-list.component';
import { InterimInvoicingOptionsComponent } from './interim-invoicing-options/interim-invoicing-options.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AcontoTypePipe } from './aconto-type.pipe';

@NgModule({
    declarations: [
        InvoicesComponent,
        InvoicesOptionsComponent,
        InvoiceContainerComponent,
        InvoiceComponent,
        InvoiceRecordComponent,
        CaseNamePipe,
        ChangeCurrencyComponent,
        InterimInvoicingModalComponent,
        InterimInvoicingListComponent,
        InterimInvoicingOptionsComponent,
        AcontoTypePipe
    ],
    imports: [
        CommonModule,
        SharedModule,
        ScrollingModule,
        InvoicesListModule
    ],
    providers: [
        CurrencyPipe,
        DatePipe
    ]
})
export class InvoicesModule { }
